"use client";

import { useCallback } from "react";
import { useRouter } from "next/navigation";
import { useActiveStore } from "../stores/useActiveStore";
import { writeSelectedStoreId } from "../lib/selected-store";

/**
 * Troca a loja ativa SEM recarregar a página.
 *
 * 1. Grava o cookie `selected_store` — é o que o SSR lê (`resolve-store.ts`).
 * 2. Atualiza o estado client na hora: quem depende da loja (carrinho via
 *    `useSessionBootstrap`, frete, cotações) reage pela mudança do `storeId`.
 * 3. `router.refresh()` re-renderiza a árvore de Server Components com o novo
 *    cookie: tema, settings, rodapé e widgets da loja nova chegam como payload
 *    RSC, sem baixar bundle de novo nem repetir os inits.
 *
 * Antes era `window.location.reload()`: um SSR completo + download de todos os
 * bundles + todos os inits, e um `/api/session/bootstrap` a mais. Sob carga a
 * diferença é um HTML inteiro por troca de loja.
 */
export function useSwitchStore(): (storeId: number) => void {
    const router = useRouter();

    return useCallback(
        (storeId: number) => {
            if (!(storeId > 0)) return;

            writeSelectedStoreId(storeId);
            const active = useActiveStore.getState();
            active.setStoreId(storeId);
            active.setReady(true);
            router.refresh();
        },
        [router]
    );
}
